<template>
    <div class="text-box" @click="onChange(true)" :style="{width: width}">
        <input type="text" ref="input" class="input"
               v-if="isInput" v-model="inputValue" v-focus="true" @blur="onChange(false)" @keypress="keypressEvent"
        />
        <span v-else>{{value}}</span>
    </div>
</template>

<script>
    export default {
        name: "TextInput",
        model: {
            prop: "value",
            event: "change"
        },
        props: {
            value: [String, Number],
            width: {
                type: String,
                default: "30px",
            }
        },
        data: () => ({
            isInput: false,
            inputValue: ""
        }),
        mounted: function () {
            this.inputValue = this.value;
        },
        methods: {
            onChange: function (state) {
                this.isInput = state;
            },
            keypressEvent: function (e) {
                let key = e.keyCode || e.which || e.charCode;
                if(key === 13) {
                    this.onChange(false);
                }
            }
        },
        watch: {
            value: function (newData) {
                this.inputValue = newData.toString();
            },
            inputValue: function (newData) {
                this.$emit("change", newData.toString());
            }
        }
    }
</script>

<style scoped>
    .text-box{
        height: 30px;
        line-height: 30px;
        min-width: 10px;
    }
    .text-box>span{
        display: inline-block;
        border: 1px solid transparent;
        width: 100%;
        height: 26px;
        line-height: 26px;
        font-size: 14px;
    }
    .input{
        height: 26px;
        font-size: 14px;
        text-align: center;
        width: 100%;
        margin: 0;
        padding: 0;
        border: 1px solid #dddddd;
    }
    .text-box:hover>span{
        border-color: #dddddd;
        background-color: #FFFFFF;
        cursor: text;
    }
</style>
